<template>
  <div class="grid-wrap">
    <div class="grid-row">
      <article class="grid-col grid-col--soft grid-xsmall-12 grid-large-9 push__bottom">
        <div class="push__top push__bottom">
            <BackLink/>
        </div>
        <Panel :title="title" variant="success" />
        <div class="wysiwyg">
            <p v-html="content"></p>
            <p>
                <button class="btn btn--primary" @click="goToNext">{{buttonText}}<span class="visually-hidden"> {{buttonTextHidden}}</span></button>
            </p>
        </div>                
      </article>
    </div>
  </div>
</template>

<script>
import { dataService } from "../shared";

export default {
  name: "Completed",
  created() {
    this.loadQuestion();
    this.loadAnswers();
  },
  data() {
    return {
      title: "",
      content: "",
      destination: "",
      buttonText: "",
      buttonTextHidden: "",
      previousResponse: null
    };
  },
  methods: {
    loadQuestion() {
      let json = dataService.getQuestions();
      let questions = json.questions;
      let currentQuestion = dataService.findElement(
        questions,
        dataService.parseUrl()
      );
      this.title = currentQuestion.title;
      this.content = currentQuestion.content;
      this.buttonText = currentQuestion.buttonText;
      this.buttonTextHidden = currentQuestion.buttonTextHidden;
    },
    loadAnswers() {
      let responses = dataService.getPatientData();
      this.previousResponse = responses;
      if (this.previousResponse.age > 10 && this.previousResponse.age < 18 && this.previousResponse.withoutHelp == "Yes") {
        this.destination = "YoungPersonEpilepsyQuestionnaire";
      } else {
        this.destination = 'YoungPersonEpilepsyQuestionnaireTogether'
      }
    },
    redirectToTimeout() {
      dataService.resetResponses();
      this.$router.push({ name: "timeout" });
    },
    goToNext() {
        this.$router.push({ path: this.destination });
    }
  }
};
</script>